import { Box, Grid } from "@material-ui/core";
import { useNotify, useRedirect } from "ra-core";

import LeftGridEdit from "../components/LeftGridEdit";
import RightGridEdit from "../components/RightGridEdit";
import LayoutContainer from "../components/LayoutContainer";
import TextInputRA from "../components/TextInputRA";
import BranchValidation from "../../../ValidationRules/BranchValidation";
import { Loading, useTranslate } from "react-admin";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import useCheckPermissionHook from "../../../hooks/useCheckPermissionHook";
const transform = (data) => {
  return {
    ...data,
    latitude: parseFloat(data.latitude ?? 0),
    longitude: parseFloat(data.longitude ?? 0),
  };
};
const BranchEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const translate = useTranslate();
  const { loading, allow } = useCheckPermissionHook({
    code: "Page.Merchant.Management.Branch",
    write: true,
  });
  if (loading) return <Loading />;
  const onSuccess = () => {
    notify(translate("ra.notification.updated")); // default message is 'ra.notification.updated'
    redirect("list", props.basePath);
  };
  const onFailure = (error) => {
    console.error(error);
    if (error.code === 123) {
      notify(
        "Could not save changes: concurrent edition in progress",
        "warning"
      );
    } else {
      notify("ra.notification.http_error", "warning");
    }
    redirect("list", props.basePath);
  };

  return (
    <LayoutContainer>
      <Grid container style={{ height: "100%" }}>
        <LeftGridEdit
          onSuccess={onSuccess}
          onFailure={onFailure}
          {...props}
          validate={BranchValidation}
          disabled={!allow}
          transform={transform}
        >
          <SfBreadcrumbs path="Management/Branches/Edit" />
          <Box style={{ margin: 50 }}>
            <TextInputRA required label="Name" source="name" />
            <TextInputRA required label="Address" source="address" />
            <TextInputRA required label="Phone" source="phone" type="phone" />
            <TextInputRA required label="Email" source="email" />
          </Box>
        </LeftGridEdit>
        <RightGridEdit resource="merchant-branches" {...props} />
      </Grid>
    </LayoutContainer>

    // <Edit
    //   mutationMode="pessimistic"
    //   onSuccess={onSuccess}
    //   onFailure={onFailure}
    //   transform={transform}
    //   {...props}
    // >
    //   <SimpleForm>
    //     <TextInputRA label="Name" source="name" />
    //     <TextInputRA label="Address" source="address" />
    //     <TextInputRA label="Phone" source="phone" type="phone" />
    //     <TextInputRA label="Email" source="email" />
    //   </SimpleForm>
    // </Edit>
  );
};

export default BranchEdit;
